import React from "react";
import styles from "./header.module.scss";

declare global {
  interface Window {
    general_settings: {
      brand_name: string;
      logo_white: string;
      favicon: string;
    };
  }
}

interface HeaderProps {
  useFavicon: boolean;
  favicon?: string;
  useGlobalFavicon?: boolean;
}

const Header: React.FC<HeaderProps> = ({ useFavicon, favicon, useGlobalFavicon = true }) => {
  const imageSrc = useFavicon
    ? useGlobalFavicon
      ? window.general_settings.favicon
      : favicon
    : window.general_settings.logo_white;

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <img className={styles.logo} src={imageSrc} alt={`${window.general_settings.brand_name} image`} />
      </div>
    </header>
  );
};

export default Header;
